import { render, staticRenderFns } from "./publiCheck.vue?vue&type=template&id=630ae87d&"
import script from "./publiCheck.vue?vue&type=script&lang=ts&"
export * from "./publiCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports